import pick from 'lodash-es/pick';
import { posField } from 'src/utils/posFieldUtils';
import { Ticket, TicketGroupInput } from 'src/WebApiController';

// Ticket delivery and sale related fields that should be preserved
// when ticket details are edited, or initialized as null for new tickets
const EmptyTicket: Partial<Ticket> = {
  qrCode: null,
  barcode: null,
  eTicket: null,
  ticketUrl: null,
  isWasted: null,
  externalTicketId: null,
  holdId: null,
  saleId: null,
};

export const toTicketKey = (ticket: Ticket) => `${ticket.row}-${ticket.seat}`;

export const sanitizeTicketGroups = (
  updatedTicketGroups: TicketGroupInput[],
  ticketLookup: Record<number, Record<string, Ticket>>
) => {
  return updatedTicketGroups.map((tg) => {
    // isTaxExempt mirrors taxPaid: exempt when 0, changed-flag carried so only user toggles persist
    const withTaxExempt = {
      ...tg,
      isTaxExempt: posField(
        tg.taxPaid?.value === 0,
        tg.taxPaid?.hasChanged ?? false
      ),
    };
    const originalTicketsByKey = ticketLookup[tg.ticketGroupId] || {};
    if (!tg.tickets?.value) {
      return withTaxExempt;
    }
    const sanitizedTickets = (tg.tickets?.value ?? []).map((ticket) => {
      const key = toTicketKey(ticket);
      const originalTicket = originalTicketsByKey[key];
      // If the ticket already exists, keep the delivery related fields
      if (originalTicket) {
        // all fields destructed are recalculated, keep the rest
        const originalDeliveryInfo = pick(
          originalTicket,
          Object.keys(EmptyTicket)
        );
        return { ...ticket, ...originalDeliveryInfo };
      }
      // For new ticket, populate delivery related fields with null and keep the rest of the fields
      return { ...ticket, ...EmptyTicket };
    });
    return {
      ...withTaxExempt,
      tickets: { ...tg.tickets, value: sanitizedTickets },
    };
  });
};
